import { useMemo } from 'react';

import { DateTime } from 'luxon';

import { useGetSemestersQuery } from '@school_ify/schoolify-repository/src/shared/types';

interface Semester {
  id: string;
  title: string;
  startDate: string;
  endDate: string;
  teachingStructureId: string;
  year: {
    teachingStructureId: string;
    title: string;
  };
}

export default function useSemesters() {
  const { data: semesterData, loading } = useGetSemestersQuery();

  const semesters = useMemo(() => {
    return (semesterData?.semesters || []).map(semester => {
      return {
        id: semester.id,
        title: semester.teaching_structure.title,
        startDate: semester.start_at,
        endDate: semester.end_at,
        teachingStructureId: semester?.teaching_structure?.id,
        year: {
          teachingStructureId: semester.teaching_structure?.parent?.title,
          title: semester.teaching_structure?.parent?.title,
        },
      };
    }) as Semester[];
  }, [semesterData]);

  const semester = useMemo(() => {
    const currentDate = DateTime.now().startOf('day');
    return semesters.find(
      item =>
        DateTime.fromISO(item.startDate) <= currentDate &&
        DateTime.fromISO(item.endDate) >= currentDate
    );
  }, [semesters]);

  return {
    loading,
    semesters,
    semester,
    semesterId: semester?.teachingStructureId,
  };
}
